const initSectionVisiable = function (elemnts) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof elemnts.callback === "function") {
            elemnts.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${elemnts.margin}px 0px` }
  );
  observer.observe(elemnts.element);
};
document.addEventListener("DOMContentLoaded", (event) => {
  class MarqueeSlider extends HTMLElement {
    constructor() {
      super();
      this.scrolling = this.querySelector(".scrolling--item");
      this.mainElement = this;
      initSectionVisiable({
        element: this,
        callback: this.initScroll.bind(this),
        margin: 300,
      });
      
      this.mainElement.addEventListener('click',this.sliderhover.bind(this))
    }
    initScroll() {
      const childCount = this.childElementCount === 1 ? true : false;
      if (childCount) {
        this.scrolling?.classList.add("scrolling--animated");

        for (let i = 0; i < 10; i++) {
          if (!this.scrolling) return;
          this.clone = this.scrolling.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // Animation pause and run based on visible screen
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove("scrolling--paused");
              } else {
                this.classList.add("scrolling--paused");
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );
        observer.observe(this);
      }
    }
    sliderhover(event){
    // callback function:when hover on slider
    }
  }
  customElements.define("marquee-slider", MarqueeSlider);
});
